import React, { useContext, useState } from 'react'
import { Container, Grid, IconButton, Paper, Typography } from '@mui/material'
import InputText from '../../DevComponents/InputText'
import BackEndAPI from '../../Services/BackEndAPI'
import { ContextoGlobal, ContextoGlobalInterface } from '../../GlobalStates/ContextoGlobal'
import Button from '@mui/material/Button'
import CloseIcon from '@mui/icons-material/Close'
import { MensagemTipo } from '../../GlobalStates/MensagemState'

import { useNavigate } from 'react-router-dom'
import ClsValidacao from '../../Utils/ClsValidacao'
import ClsExportDataTableCSV from '../../Utils/ClsExportDataTableCSV'
import { RelatorioConciliacaoExtratoInterface } from '../../ImportBackend/Interfaces/RelatorioInterfaces'
import { DataTableCabecalhoInterface } from '../../DevComponents/DataTable'
import { RespostaPadraoInterface } from '../../ImportBackend/Interfaces/PadraoInterfaces'

interface PesquisaInterface {
  dataInicial: string
  dataFinal: string
}

export default function RelCreditosPorUnidade () {

  const CabecalhoExportacao: Array<DataTableCabecalhoInterface> = [
    {
      campo: 'data',
      cabecalho: 'Data',
      alinhamento: 'left'
    },
    {
      campo: 'cpf',
      cabecalho: 'CPF',
      alinhamento: 'left'
    },
    {
      campo: 'cliente',
      cabecalho: 'Cliente',
      alinhamento: 'left'
    },
    {
      campo: 'valor',
      cabecalho: 'Valor',
      alinhamento: 'left'
    },
    {
      campo: 'unidade',
      cabecalho: 'Unidade',
      alinhamento: 'left'
    }
  ]

  const clsApi = new BackEndAPI()

  const contexto = useContext( ContextoGlobal ) as ContextoGlobalInterface
  const { mensagemState, setMensagemState } = contexto

  const [errosPesquisa, setErrosPesquisa] = useState( {} )

  const [pesquisa, setPesquisa] = useState<PesquisaInterface>( {
    dataInicial: '',
    dataFinal: ''
  } )

  const navigate = useNavigate()

  const btFechar = () => {
    navigate( '/' )
  }

  const validarPesquisa = (): boolean => {
    let retorno: boolean = true
    let erros: { [key: string]: string } = {}

    let clsValidacao = new ClsValidacao()

    retorno = clsValidacao.eData( 'dataInicial', pesquisa, erros, retorno, true )
    retorno = clsValidacao.eData( 'dataFinal', pesquisa, erros, retorno, true )

    if ( retorno
      && pesquisa.dataInicial.length > 0
      && pesquisa.dataFinal.length > 0
      && pesquisa.dataInicial > pesquisa.dataFinal
    ) {
      erros.dataInicial = 'Período Inválido!'
      erros.dataFinal = 'Período Inválido!'
      retorno = false
    }

    setErrosPesquisa( erros )

    return retorno
  }

  const onClickDownload = () => {

    if ( validarPesquisa() ) {

      const query = `
        relCreditosPorUnidade(
          inicio: "${pesquisa.dataInicial}",
          termino: "${pesquisa.dataFinal}"
        )
        {
          ok
          mensagem
        }
      `

      clsApi.query<RespostaPadraoInterface>( query, 'relCreditosPorUnidade', 'Pequisando Movimentação...', contexto ).then( rsContaCorrente => {

        if ( rsContaCorrente.ok ) {

          ( new ClsExportDataTableCSV() ).exportCSV( 'CreditosPorUnidade', JSON.parse( rsContaCorrente.mensagem ), CabecalhoExportacao )

        } else {

          setMensagemState( {
            ...mensagemState,
            titulo: 'Erro! Consulte Suporte!',
            exibir: true,
            mensagem: rsContaCorrente.mensagem,
            tipo: MensagemTipo.Error,
            exibirBotao: true
          } )

        }

      } ).catch( () => {

        setMensagemState( {
          ...mensagemState,
          titulo: 'Erro! Consulte Suporte!',
          exibir: true,
          mensagem: 'Erro ao Consultar Créditos Por Unidade!',
          tipo: MensagemTipo.Error,
          exibirBotao: true
        } )

      } )

    }

  }

  return (
    <>
      <Container maxWidth="sm" sx={{ mt: 15 }}>

        <Paper variant="outlined" sx={{ padding: 2 }}>
          <Grid container sx={{ display: 'flex', alignItems: 'center' }}>

            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
              <Typography component="h5" variant="h5" align="left">
                Créditos Por Unidade
                <Typography variant="body2" gutterBottom>
                  Download dos créditos por unidade, no período selecionado.
                </Typography>
              </Typography>

              <IconButton onClick={() => btFechar()}>
                <CloseIcon />
              </IconButton>
            </Grid>

            <Grid item xs={12} sx={{ mb: 3 }}>

              <Grid container sx={{ display: 'flex', alignItems: 'center' }}>

                <Grid item xs={12} sm={6}>

                  <InputText
                    dados={pesquisa}
                    field='dataInicial'
                    label='Início'
                    setState={setPesquisa}
                    erros={errosPesquisa}
                    tipo='date'
                    mask='00/00/0000'
                    textAlign="right"
                  />

                </Grid>

                <Grid item xs={12} sm={6} sx={{ pl: { sm: 1 } }}>

                  <InputText
                    dados={pesquisa}
                    field='dataFinal'
                    label='Término'
                    setState={setPesquisa}
                    erros={errosPesquisa}
                    tipo='date'
                    mask='00/00/0000'
                    textAlign="right"
                  />

                </Grid>

                <Grid item xs={12} sx={{ textAlign: 'right', mt: 3 }}>
                  <Button variant='contained' onClick={() => onClickDownload()}>Download</Button>
                </Grid>

              </Grid>

            </Grid>

          </Grid>
        </Paper>

      </Container>
    </>
  )
}